module.exports = __webpack_public_path__ + "assets/img/returnBtn-d3bf2765.png";